/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import { BLACK } from '../../../styles/colors';


/**
 * A common, styled option for selects (comboboxes)
 */
export const Option = styled('option')`
  font-weight: normal;
  display: block;
  white-space: pre;
  min-height: 1.2em;
  padding: 0 2px 1px;
  color: ${BLACK};
  letter-spacing: -.4px;
  cursor: pointer;
`;
